import React from 'react';
import { Helmet } from 'react-helmet-async';
import { defineMessages, useIntl } from 'react-intl';
import useConfig from '../hooks/useConfig';
export var metaInformation = defineMessages({
    robots: {
        id: 'page.robots',
        defaultMessage: '{robots}',
    },
    title: {
        id: 'page.title',
        defaultMessage: '{title}',
    },
    description: {
        id: 'page.description',
        defaultMessage: '{description}',
    },
    canonical: {
        id: 'page.canonical',
        defaultMessage: '{canonical}',
    },
});
export var Meta = function (_a) {
    var _b, _c, _d;
    var children = _a.children, language = _a.language;
    var config = useConfig();
    var intl = useIntl();
    var metaRobots = (config === null || config === void 0 ? void 0 : config.headerInformation) ? (React.createElement("meta", { name: "ROBOTS", content: intl.formatMessage(metaInformation.robots, {
            robots: (_b = config === null || config === void 0 ? void 0 : config.headerInformation[language]) === null || _b === void 0 ? void 0 : _b.robots,
        }) })) : null;
    var metaTitle = (config === null || config === void 0 ? void 0 : config.headerInformation) ? (React.createElement("title", null, intl.formatMessage(metaInformation.title, {
        title: (_c = config === null || config === void 0 ? void 0 : config.headerInformation[language]) === null || _c === void 0 ? void 0 : _c.title,
    }))) : null;
    var metaDesc = (config === null || config === void 0 ? void 0 : config.headerInformation) ? (React.createElement("meta", { name: "description", content: intl.formatMessage(metaInformation.description, {
            description: (_d = config === null || config === void 0 ? void 0 : config.headerInformation[language]) === null || _d === void 0 ? void 0 : _d.description,
        }) })) : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            metaRobots,
            metaTitle,
            metaDesc),
        children));
};
export default Meta;
//# sourceMappingURL=index.js.map